import { connect } from 'react-redux'
import { compose } from 'redux'

import type { IAccessState } from './access'
import { F_PUBLIC, userLevelSelector } from './access'

interface IProps {
  access: number,
  level: number,
  fallback?: null | JSX.Element,
  children: JSX.Element | null | boolean
}

function CheckAccess({ access = F_PUBLIC, level, fallback = null, children }: IProps): JSX.Element | null {
  if(typeof children === 'boolean') {
    return fallback
  }
  return level & access ? children : fallback
}

export default compose(
  connect(
    (state: IAccessState) => ({
      level: userLevelSelector({
        featureFlags: state.featureFlags,
        common: state.common,
      }),
    })
  ),
)(CheckAccess)
